import React from 'react'
import TextField from '@material-ui/core/TextField'

const renderTextField = ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => (
  <TextField
    id={label}
    label={label}
    error={touched && !!error}
    helperText={touched && error}
    {...input}
    {...custom}
  />
)

export default renderTextField



// WEBPACK FOOTER //
// ./src/forms/renderTextField.js